export interface SessionVideoLike {
  id: string;
  filename: string;
  originalFilename: string;
  fileSize?: number;
  durationSeconds?: number;
  resolution?: string;
  format?: string;
  createdAt?: string;
}

export interface SessionTicketLike {
  finalVideoFilename?: string | null;
  status?: string;
}

export function isSourceClip(video: SessionVideoLike): boolean {
  return !video.filename.startsWith('combined-');
}

/** Clips uploaded for editing/reorder — excludes combined output files. */
export function getSourceClips(videos: SessionVideoLike[]): SessionVideoLike[] {
  return videos.filter(isSourceClip);
}

export function getCombinedFromVideos(videos: SessionVideoLike[]): SessionVideoLike | null {
  const combined = videos.filter((v) => v.filename.startsWith('combined-'));
  if (combined.length === 0) return null;
  return combined[combined.length - 1];
}

/** Prefer ticket final filename; fall back to combined-* in videos list. */
export function resolveFinalVideo(
  videos: SessionVideoLike[],
  ticket?: SessionTicketLike | null
): SessionVideoLike | null {
  const fromTicket = ticket?.finalVideoFilename?.trim();
  if (fromTicket) {
    const match = videos.find((v) => v.filename === fromTicket);
    if (match) return match;
    return {
      id: 'combined-final',
      filename: fromTicket,
      originalFilename: 'Final combined video',
      durationSeconds: 0,
      resolution: 'Unknown',
      format: 'mp4',
      createdAt: new Date().toISOString(),
    };
  }

  return getCombinedFromVideos(videos);
}

export function buildTempStreamPath(filename: string): string {
  return `videos/temp/${encodeURIComponent(filename)}`;
}

/** Fills defaults for synthetic combined-video rows and optional API fields. */
export function normalizeSessionVideo(video: SessionVideoLike) {
  return {
    id: video.id,
    filename: video.filename,
    originalFilename: video.originalFilename?.trim() || video.filename,
    filePath: video.filename,
    fileSize: video.fileSize ?? 0,
    durationSeconds: video.durationSeconds ?? 0,
    resolution: video.resolution ?? 'Unknown',
    format: video.format ?? 'mp4',
    createdAt: video.createdAt ?? '',
  };
}
